import script from "./hotmap.vue?vue&type=script&setup=true&lang=js"
export * from "./hotmap.vue?vue&type=script&setup=true&lang=js"

import "./hotmap.vue?vue&type=style&index=0&id=dd5de95a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd5de95a"]])

export default __exports__